import React from 'react'
import { ListItem } from '@material-ui/core'
import { PURPLE } from 'constants/colors'
import Checkbox from '../Checkbox'
import Radio from '../Radio'
import { StyledListItem, StyledMenu, MenuTitle } from './Menu.styles'
import { MenuProps } from './Menu.types'

const Menu = ({
  onClick,
  anchorEl,
  setAnchorEl,
  closeOnSelect = false,
  menuItems,
  title,
  renderMenuBody,
  selectedValue,
  getFormatMessage = label => label,
  onClose,
  multiple = false,
}: MenuProps) => (
  <StyledMenu
    keepMounted
    anchorEl={anchorEl}
    open={!!anchorEl}
    onClose={() => {
      onClose?.()
      setAnchorEl(null)
    }}>
    {title && <MenuTitle>{title}</MenuTitle>}
    {renderMenuBody?.() ||
      menuItems?.map(menuItem => {
        const { value, label } = menuItem
        const isSelected =
          multiple && Array.isArray(selectedValue)
            ? selectedValue?.some(val => val === value)
            : value === selectedValue

        return (
          <StyledListItem key={value}>
            <ListItem
              onClick={() => {
                if (!isSelected || multiple) {
                  onClick?.(menuItem)
                }

                if (closeOnSelect) {
                  setAnchorEl(null)
                }
              }}>
              {multiple ? (
                <Checkbox
                  checked={isSelected}
                  onChange={event => event.preventDefault()}
                  color={PURPLE}
                />
              ) : (
                <Radio
                  checked={isSelected}
                  onChange={event => event.preventDefault()}
                  color={PURPLE}
                />
              )}
              {getFormatMessage(label)}
            </ListItem>
          </StyledListItem>
        )
      })}
  </StyledMenu>
)

export default Menu
